// Server error details can be a string, or a Pydantic validation
// error array [{type, loc, msg, input, ctx, url}] — never render raw.
export const formatDetail = (detail, fallback = "Something went wrong") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join("; ");
  return String(detail?.msg || detail);
};
